import type { ReactNode } from 'react';
import { Redirect } from 'react-router-dom';

import { useModuleLevel } from '~/api/hooks/useCompany';
import { ROUTES } from '~/routes';
import { ACCESS_LEVEL, type AccessLevel, type ModuleKey, atLeast } from '~/session/access';

interface RequireModuleProps {
  module: ModuleKey;
  /** Nível mínimo na empresa em operação. Padrão: consulta. */
  level?: AccessLevel;
  children: ReactNode;
}

/**
 * Protege uma rota pelo nível do usuário no módulo, na empresa selecionada. Abaixo do
 * mínimo, volta ao painel: é o mesmo que o backend faria com 403, só que sem a tela
 * quebrada. Deve ficar dentro de `RequireAuth`, que já esperou a sessão hidratar.
 */
export function RequireModule({
  module,
  level = ACCESS_LEVEL.read,
  children,
}: RequireModuleProps): JSX.Element {
  const granted = useModuleLevel(module);

  if (!atLeast(granted, level)) {
    return <Redirect to={ROUTES.dashboard} />;
  }

  return <>{children}</>;
}
